/**
 * Formats a number of bytes into a human-readable string.
 * Shows 3 decimal places max.
 * @param bytes - The number of bytes to format.
 * @returns A human-readable string.
 */
export const formatBytes = (bytes: number): string => {
  if (bytes >= 1024 * 1024 * 1024) {
    const gigabytes = bytes / (1024 * 1024 * 1024);
    return `${gigabytes.toFixed(gigabytes < 100 ? 1 : 0)} GB`;
  }
  if (bytes >= 1024 * 1024) {
    const megabytes = bytes / (1024 * 1024);
    return `${megabytes.toFixed(megabytes < 100 ? 1 : 0)} MB`;
  }
  if (bytes >= 1024) {
    const kilobytes = bytes / 1024;
    return `${kilobytes.toFixed(kilobytes < 100 ? 1 : 0)} KB`;
  }
  return `${bytes} B`;
};
